import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../api";
import { notify } from "../../utils/toast";
import axios from "axios";

export const Dashboard = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [thisMonth, setThisMonth] = useState(0);
  const [sixMonth, setSixMonth] = useState(0);
  const [yearAgo, setYearAgo] = useState(0);
  const [total, setTotal] = useState(0);
  const [activeEmp, setActiveEmp] = useState(0);
  const [inactiveEmp, setInactiveEmp] = useState(0);

  const getData = async () => {
    try {
      let token = localStorage.getItem("admintoken");
      axios.defaults.headers.common["Authorization"] = token;
      const response = await api.getDashboard();
      console.log(response);
      if (response?.success) {
        setData(response?.recentEmployees || []);
        setTotal(response?.totalEmployees || 0);
        setThisMonth(response?.employeesThisMonth || 0);
        setSixMonth(response?.employeesMoreThanSixMonths || 0);
        setYearAgo(response?.employeesMoreThanOneYear || 0);
        setActiveEmp(response?.activeCount || 0);
        setInactiveEmp(response?.offCount || 0);
      }
    } catch (error) {
      notify.error("Something went wrong");
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      {/* Begin Page Content */}
      <div className="DashboardMain">
        <div className="row analytics-row">
          <AnalyticsBox
            icon={<i className="fa-solid fa-users"></i>}
            title="Total Employees"
            amount={total}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-handshake"></i>}
            title="Join This Months"
            amount={thisMonth}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-handshake"></i>}
            title="Join More Than 6 Months"
            amount={sixMonth}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-champagne-glasses"></i>}
            title="Join More Than A Year"
            amount={yearAgo}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-users"></i>}
            title="Available Employees"
            amount={activeEmp}
          />
          <AnalyticsBox
            icon={<i className="fa-solid fa-users"></i>}
            title="In-Active Employee"
            amount={inactiveEmp}
          />
        </div>
        <div className="row">
          <div className="col">
            <h3>Recent Employees</h3>
            <Table data={data ? data : []} />
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
    </>
  );
};

function AnalyticsBox(props) {
  return (
    <div className="col-xl-3 col-md-6 mb-4">
      <div className="card h-100 py-2 border-transparent br-10 bg-gray1">
        <div className="card-body">
          <div className="row no-gutters align-items-center">
            <div className="col">
              {/* <img className="analytic-box-img" src={props.icon} alt="" /> */}
              <div className="analytic-box-img">{props.icon}</div>
            </div>
            <div className="col-auto mr-2">
              <div className="text-xs font-weight-bold  mb-1">
                <span className="analytics-box-title">{props.title}</span>
              </div>
              <div className="h3 mb-0 font-weight-bold text-gray-800">
                {props.amount}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Table = ({ data }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY");
    return dateTemp;
  };

  return (
    <>
      <div className="TableMain mt-3">
        <div className="table-responsive">
          <table className="table table-hover drivers-table">
            <thead>
              <tr>
                <th scope="col" className="">
                  Full Name
                </th>
                <th scope="col" className="">
                  DOB
                </th>
                <th scope="col" className="">
                  Gender
                </th>

                <th scope="col" className="">
                  Contact
                </th>
                <th scope="col" className="">
                  Email Address
                </th>
                <th scope="col" className="">
                  Join At
                </th>
                <th scope="col" className=""></th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, key) => (
                <tr key={key}>
                  <td>
                    <div className="table-text-dark w-max-c db">
                      {item?.fullName}
                    </div>
                  </td>
                  <td scope="row" className="d-flex">
                    <div className="table-text-dark w-max-c db">
                      {item?.dob ? formatDate(item?.dob) : "-"}
                    </div>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.gender}
                    </span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.contactNumber}
                    </span>
                  </td>
                  <td>
                    <span className="table-text-dark w-max-c db">
                      {item?.email}
                    </span>
                  </td>
                  <td>
                    {item?.joiningDate ? formatDate(item?.joiningDate) : "-"}
                  </td>
                  <td>
                    <Link
                      to={`/admin/employee/${item?._id}`}
                      className="p-2 cursor-pointer color-dark"
                    >
                      <i className="fa-solid fa-eye"></i>
                    </Link>{" "}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
